import theme from 'ui/styles/theme'

export const largerThan = (current, test) => theme.grid.breakpoints[current] > theme.grid.breakpoints[test]
export const smallerThan = (current, test) => theme.grid.breakpoints[current] < theme.grid.breakpoints[test]


// WEBPACK FOOTER //
// ./src/utils/media.js